import { PortalAwardOutcomeDto, type PortalAwardLetterDto } from "../../../../autogen/bff-api";
import { winnerNamesText, type StandstillTerms } from "../../../sourcing-event/award/awardLetterTemplates";

export const portalStandstillTerms = (award: PortalAwardLetterDto): StandstillTerms => ({
  buyerSetsStandstill: award.buyerSetsStandstill ?? false,
  voluntary: award.choosesVoluntaryStandstill ?? false,
  days: award.standstillDays,
  exemption: award.standstillExemption,
  expiresAt: award.standstillExpiresAt,
  rejectedInFavourOf: award.outcome === PortalAwardOutcomeDto.Winner ? null : winnerNamesText(award.winnerNames ?? []),
});
